import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    available: [...construction.available.uplift],
    info: construction.info.uplift,
    loaded: construction.parameters_loaded,
    selected: construction.selected.uplift
  })
);
